import { render, staticRenderFns } from "./AddPurchase.vue?vue&type=template&id=7f467720&scoped=true&"
var script = {}
import style0 from "./AddPurchase.vue?vue&type=style&index=0&id=7f467720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f467720",
  null
  
)

export default component.exports